import { TableHeaderColumn } from '@/modules/drivers/types'


export const getImiValidationColumns = (
  t: (key: string) => string,
): TableHeaderColumn[] => [
  { title: t('imiExport.driver'), key: null, type: 'string', sort: false },
  { title: t('imiExport.status'), key: null, type: 'string', sort: false },
  { title: t('imiExport.date'), key: null, type: 'date', sort: false },
  { title: t('imiExport.country'), key: null, type: 'string', sort: false },
  {
    title: t('imiExport.operation-type'),
    key: null,
    type: 'string',
    sort: false,
  },
  {
    title: t('imiExport.transport-type'),
    key: null,
    type: 'string',
    sort: false,
  },
  { title: t('imiExport.vehicles'), key: null, type: 'string', sort: false },
]
